import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ApplicationBarComponent} from "./ApplicationBarComponent";
import {ApplicationBarLayoutComponent} from "./ApplicationBarLayoutComponent";
import {TooltipModule} from "ngx-tooltip";
import {EnvironmentComponentModule} from "@nordpoolgroup/nps-angular-2-common";

@NgModule({
    declarations: [
        ApplicationBarComponent,
        ApplicationBarLayoutComponent
    ],
    imports: [
        BrowserModule,
        TooltipModule,
        EnvironmentComponentModule
    ],
    exports: [
        ApplicationBarComponent,
        ApplicationBarLayoutComponent
    ]
})

export class ApplicationBarLayoutModule { }



// WEBPACK FOOTER //
// ./src/app/ApplicationBar/ApplicationBarLayoutModule.ts